import React from 'react';
import PropTypes from 'prop-types';

import Page from 'components/Page';
import RadioList from 'components/RadioList';
import Button from 'components/Button';
import Footer from 'components/Footer';

import handleInputChange from 'utils/handleInputChange';

/* eslint-disable max-len */
export class InterestAccreditation extends React.Component {
  constructor() {
    super();

    // default props
    this.state = {};

    // handlers
    this.handleInputChange = handleInputChange.bind(this);
    this.handlePageSubmit = this.handlePageSubmit.bind(this);
  }
  handlePageSubmit() {
    // dispatch submit
    this.props.submit({
      accredited: this.state.accredited,
    });
  }
  canSubmit() {
    return !this.state.accredited;
  }
  renderWhoLanguage() {
    if (this.props.investor.type === 'trust' || this.props.investor.type === 'company') {
      return `${this.props.investor.name} is an accredited investor because:`;
    }
    return 'I am an acredited investor because I have:';
  }
  renderNetWorthLanguage() {
    if (this.props.investor.type === 'trust' || this.props.investor.type === 'company') {
      return 'This entity has more then $5m in investments';
    }
    return 'A net worth of over $1M, excluding my primary residence';
  }
  renderIncomeLanguage() {
    if (this.props.investor.type === 'trust' || this.props.investor.type === 'company') {
      return 'All equity owners in this entity are themselves accredited investors';
    }
    return 'An annual income of over $200k (or $300k jointly with spouse) for the past two years, and expect the same this year';
  }
  render() {
    return (
      <section className="pageContainer">
        <Page>
          <h2>Accreditation</h2>
          <p>{this.renderWhoLanguage()}</p>
          <RadioList>
            <p>
              <input type="radio" id="accredited_net_worth" name="accredited" value="net_worth" onChange={this.handleInputChange} data-test="accreditation_option" />
              <label htmlFor="accredited_net_worth">{this.renderNetWorthLanguage()}</label>
            </p>
            <p>
              <input type="radio" id="accredited_income" name="accredited" value="income" onChange={this.handleInputChange} />
              <label htmlFor="accredited_income">{this.renderIncomeLanguage()}</label>
            </p>
          </RadioList>
          <Footer>
            <Button onClick={this.handlePageSubmit} disabled={this.canSubmit()} data-test="accreditation_submit">
              Continue
            </Button>
          </Footer>
        </Page>
      </section>
    );
  }
}
/* eslint-enable max-len */

InterestAccreditation.propTypes = {
  submit: PropTypes.func.isRequired,
  investor: PropTypes.object.isRequired,
};

export default InterestAccreditation;



// WEBPACK FOOTER //
// ./web/flows/interest/accreditation/component.js